import { useDraggable } from '@dnd-kit/core'
import { JobListItem } from '../JobList/jobListItem'
import JobKanbanCard from './JobKanbanCard'

type Props = {
  job: JobListItem
  accent: string
  from: number
  condensed?: boolean
}

const DraggableJobKanbanCard = ({ job, accent, from, condensed }: Props) => {
  const { setNodeRef, attributes, listeners, isDragging } = useDraggable({
    id: job.id,
    data: { job, from }
  })

  return <JobKanbanCard
    job={job}
    accent={accent}
    innerRef={setNodeRef}
    dragging={isDragging}
    condensed={condensed}
    {...attributes}
    {...listeners}
  />
}

export default DraggableJobKanbanCard
